import { LSubTitle } from "./LSubtitle";

export const Transitions = ({ currentCaption }: TransitionsProps): JSX.Element => {
    return (
        <div className="container has-text-centered m-6">
            <LSubTitle>{currentCaption}</LSubTitle>
        </div>
    );
};

interface TransitionsProps {
    currentCaption: string;
}
